module.exports = __webpack_public_path__ + "img/header-engagementRingsGold.3459db0.jpg";